import { useMemo } from 'react';
import { getPath } from '@/router/utils';
import {
  ROUTE_STOCKS_MARKET,
  ROUTE_STOCKS_MARKET_INDUSTRY,
} from '@/constants/routes';
import { DEFAULT_INDUSTRY } from '../constants';

interface SortByOptions {
  option: string;
  href?: string;
  label: string;
}

export type SortBy =
  | 'market-cap-large'
  | 'market-cap-small'
  | 'top-gainers'
  | 'biggest-losers'
  | 'growth'
  | 'dividend-yield-high';

export type SortByLabel =
  | 'Market Cap High to Low'
  | 'Market Cap Low to High'
  | 'Top Gainers Today'
  | 'Biggest Losers Today'
  | 'Growth'
  | 'Dividend Yield';

export const sortByLabelMap: Record<SortBy, SortByLabel> = {
  'market-cap-large': 'Market Cap High to Low',
  'market-cap-small': 'Market Cap Low to High',
  'top-gainers': 'Top Gainers Today',
  'biggest-losers': 'Biggest Losers Today',
  growth: 'Growth',
  'dividend-yield-high': 'Dividend Yield',
};

const sortByList: [string, SortByLabel][] = Object.entries(sortByLabelMap);

export default function useSortByOptions(
  market: string,
  industry: string
): SortByOptions[] {
  const route =
    industry !== DEFAULT_INDUSTRY
      ? ROUTE_STOCKS_MARKET_INDUSTRY
      : ROUTE_STOCKS_MARKET;
  const sortByOptions = useMemo(
    () => [
      ...sortByList.map((sortBy) => {
        const path = sortBy[0];
        const payload = {
          market,
          industry,
          sortBy: path,
        };
        return {
          option: path,
          label: sortBy[1],
          href: getPath({
            type: route,
            payload,
          }),
        };
      }),
    ],
    [market, industry, route]
  );

  return sortByOptions;
}
